export default "__VITE_ASSET__DDCmlqj8__"